import * as React from "react";
import { forwardRef } from "react";
const SvgRecruit = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 18, height: 18, viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round", className: "lucide lucide-megaphone", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "m3 11 18-5v12L3 14v-3z" }), /* @__PURE__ */ React.createElement("path", { d: "M11.6 16.8a3 3 0 1 1-5.8-1.6" }));
const ForwardRef = forwardRef(SvgRecruit);
export { ForwardRef as ReactComponent };
